import * as React from 'react';
import { Box, Grid, Button, Paper, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, TextField, Chip, Typography, Dialog, DialogTitle, DialogContent, IconButton, Tooltip, Autocomplete } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Skeleton from '@mui/material/Skeleton';

import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

import SearchIcon from '@mui/icons-material/Search';
import CachedIcon from '@mui/icons-material/Cached';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';

import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';


const GetTimeFormat = (time) => {
    let hours = 0;
    let minutes = 0;
    let seconds = 0;
    hours = Math.floor(time / 3600);
    minutes = Math.floor((time - (hours * 3600)) / 60);
    seconds = time - (hours * 3600) - (minutes * 60);

    if (hours == 0) {
        hours = '';
    }
    else {
        hours = hours + ' H ';
    }


    if (minutes == 0) {
        minutes = '';
    }
    else {
        minutes = minutes + ' M ';
    }

    if (seconds == 0) {
        seconds = '';
    }
    else {
        seconds = seconds + ' S ';
    }


    let final_time = hours + minutes + seconds;

    if (final_time == '') {
        final_time = 0
    }

    return final_time;
}

export const StudentsCountComp = (props) => {
    return (
        <Box>
            <Box>
                <Grid container>
                    <Grid md={3}>
                        <Box marginTop={-1}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={['DatePicker']}>
                                    <DatePicker onChange={(e) => props.HandleInputs(e, 'txtSearchStartDate')} label="Start Date" value={dayjs(props.mystate.txtSearchStartDate)} />
                                </DemoContainer>
                            </LocalizationProvider>
                        </Box>
                    </Grid>
                    <Grid md={3}>
                        <Box marginTop={-1}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={['DatePicker']}>
                                    <DatePicker onChange={(e) => props.HandleInputs(e, 'txtSearchEndDate')} label="End Date" value={dayjs(props.mystate.txtSearchEndDate)} />
                                </DemoContainer>
                            </LocalizationProvider>
                        </Box>
                    </Grid>

                    <Grid xs={12} md={3}>
                        <Box>
                            <Autocomplete
                                options={props.mystate.instituteListData || []}
                                getOptionLabel={(option) => option.institute_name || ''}
                                value={
                                    props.mystate.instituteListData.find(
                                        item =>
                                            item.institute_name ===
                                            props.mystate.ddlSearchInstitute
                                    ) || null
                                }
                                onChange={(event, newValue) => {
                                    props.HandleInputs(
                                        {
                                            target: {
                                                value: newValue?.institute_name || ''
                                            }
                                        },
                                        'ddlSearchInstitute'
                                    );
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Student Referred By"
                                        error={Boolean(
                                            props.mystate.ddlSearchInstituteErr
                                        )}
                                    />
                                )}
                            />

                        </Box>
                    </Grid>



                    <Grid md={2}>
                        <Box textAlign={'end'}>
                            <Button style={{ margin: 10 }} variant="outlined" onClick={() => props.CustomSearch()}><SearchIcon></SearchIcon></Button>
                            <Button style={{ margin: 10 }} variant="outlined" onClick={() => props.Reload()}><CachedIcon></CachedIcon></Button>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
            <Box style={{ marginTop: '20px' }}>

                {
                    props.mystate.getCallLogsCount === false ?
                        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                            <TableContainer
                                sx={{
                                    maxHeight: 'calc(100vh - 200px)'
                                }}
                            >
                                <Table stickyHeader>

                                    <TableHead>

                                        <TableRow>

                                            <TableCell className="table-head-cell">
                                                #
                                            </TableCell>

                                            <TableCell className="table-head-cell">
                                                Institute Name
                                            </TableCell>

                                            <TableCell className="table-head-cell" align="center">
                                                <Tooltip arrow title="Student Referred">
                                                    <span>REFERRED</span>
                                                </Tooltip>
                                            </TableCell>

                                            <TableCell className="table-head-cell" align="center">
                                                <Tooltip arrow title="Preliminary Screening Done">
                                                    <span>PSD</span>
                                                </Tooltip>
                                            </TableCell>

                                            <TableCell className="table-head-cell" align="center">
                                                <Tooltip arrow title="Language Screening Done">
                                                    <span>LSD</span>
                                                </Tooltip>
                                            </TableCell>

                                            <TableCell className="table-head-cell" align="center">
                                                <Tooltip arrow title="Resume Ready">
                                                    <span>RR</span>
                                                </Tooltip>
                                            </TableCell>

                                            <TableCell className="table-head-cell" align="center">
                                                <Tooltip arrow title="Interview With Agency">
                                                    <span>IWA</span>
                                                </Tooltip>
                                            </TableCell>

                                            <TableCell className="table-head-cell" align="center">
                                                <Tooltip arrow title="COL Issued">
                                                    <span>COL</span>
                                                </Tooltip>
                                            </TableCell>

                                            <TableCell className="table-head-cell" align="center">
                                                <Tooltip arrow title="COL Accepted, Agreement Done">
                                                    <span>AD</span>
                                                </Tooltip>
                                            </TableCell>

                                            <TableCell className="table-head-cell" align="center">
                                                <Tooltip arrow title="Security Deposit Paid">
                                                    <span>SDP</span>
                                                </Tooltip>
                                            </TableCell>

                                            <TableCell className="table-head-cell" align="center">
                                                <Tooltip arrow title="Interviewing With Hospital">
                                                    <span>IWH</span>
                                                </Tooltip>
                                            </TableCell>

                                            <TableCell className="table-head-cell" align="center">
                                                <Tooltip arrow title="Final Offer Issued">
                                                    <span>FOI</span>
                                                </Tooltip>
                                            </TableCell>

                                        </TableRow>

                                    </TableHead>

                                    <TableBody>

                                        {
                                            props.mystate.callCountData?.length > 0 ?

                                                props.mystate.callCountData.map((item, i) => {

                                                    const total =
                                                        // item.REFFERRED +
                                                        item.PSD +
                                                        item.LSD +
                                                        item.RR +
                                                        item.IWA +
                                                        item.COL +
                                                        item.AD +
                                                        item.SDP +
                                                        item.IWH +
                                                        item.FOI;

                                                    return (

                                                        <TableRow
                                                            hover
                                                            key={i}
                                                        >

                                                            <TableCell>
                                                                {i + 1}
                                                            </TableCell>

                                                            <TableCell>

                                                                <Typography
                                                                    sx={{
                                                                        fontWeight: 600,
                                                                        color: '#042740'
                                                                    }}
                                                                >
                                                                    {item.institute_name}
                                                                </Typography>

                                                            </TableCell>

                                                            <TableCell align="center">
                                                                <Chip
                                                                    label={item.REFFERRED}
                                                                    size="small"
                                                                    color="primary"
                                                                />
                                                            </TableCell>

                                                            <TableCell align="center">
                                                                {item.PSD}
                                                            </TableCell>

                                                            <TableCell align="center">
                                                                {item.LSD}
                                                            </TableCell>

                                                            <TableCell align="center">
                                                                {item.RR}
                                                            </TableCell>

                                                            <TableCell align="center">
                                                                {item.IWA}
                                                            </TableCell>

                                                            <TableCell align="center">
                                                                {item.COL}
                                                            </TableCell>

                                                            <TableCell align="center">
                                                                {item.AD}
                                                            </TableCell>

                                                            <TableCell align="center">
                                                                {item.SDP}
                                                            </TableCell>

                                                            <TableCell align="center">
                                                                {item.IWH}
                                                            </TableCell>

                                                            <TableCell align="center">
                                                                {item.FOI}
                                                            </TableCell>

                                                            <TableCell align="center">

                                                                <Chip
                                                                    label={total}
                                                                    color="success"
                                                                    sx={{
                                                                        fontWeight: 700
                                                                    }}
                                                                />

                                                            </TableCell>

                                                        </TableRow>

                                                    );

                                                })

                                                :

                                                <TableRow>

                                                    <TableCell
                                                        colSpan={13}
                                                        align="center"
                                                    >

                                                        <Typography py={3}>
                                                            No Record Found
                                                        </Typography>

                                                    </TableCell>

                                                </TableRow>
                                        }

                                    </TableBody>

                                </Table>

                            </TableContainer>

                        </Paper>
                        :
                        <Box>
                            <Skeleton height={75} />
                            <Skeleton animation="wave" variant="rectangular" height={250} />
                            <Skeleton height={75} />
                        </Box>
                }

            </Box>

            <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'right' }} open={props.mystate.showAlert} autoHideDuration={2000} onClose={() => { props.handleCloseAlert() }}>
                <Alert
                    onClose={() => { props.handleCloseAlert() }}
                    severity={'error'}
                    variant="filled"
                    sx={{ width: '100%' }}

                >
                    {props.mystate.alertMsg}
                </Alert>
            </Snackbar>

            <Dialog
                open={props.mystate.callLogsPopup}
                onClose={() => props.CloseCallLogs(false)}
                fullWidth
                maxWidth="lg"
            >

                <DialogTitle>

                    Call Logs

                    <Typography
                        variant="body2"
                        color="text.secondary"
                    >
                        {props.mystate.selectedUser} - {props.mystate.selectedType}
                    </Typography>

                </DialogTitle>

                <DialogContent>

                    <TableContainer>

                        <Table>

                            <TableHead>

                                <TableRow>

                                    <TableCell>
                                        Date
                                    </TableCell>

                                    <TableCell>
                                        From
                                    </TableCell>

                                    <TableCell>
                                        To
                                    </TableCell>

                                    <TableCell>
                                        Status
                                    </TableCell>

                                    <TableCell>
                                        Duration
                                    </TableCell>

                                    <TableCell>
                                        Recording
                                    </TableCell>

                                </TableRow>

                            </TableHead>

                            <TableBody>

                                {
                                    props.mystate.callLogs.map((log, index) => (

                                        <TableRow key={index}>

                                            <TableCell>
                                                {log.call_start_time}
                                            </TableCell>

                                            <TableCell>
                                                {log.call_from_number}
                                            </TableCell>

                                            <TableCell>
                                                {log.call_to_number}
                                            </TableCell>

                                            <TableCell>

                                                <Chip
                                                    size="small"
                                                    color={
                                                        log.call_status === 'completed'
                                                            ? 'success'
                                                            : 'warning'
                                                    }
                                                    label={log.call_status}
                                                />

                                            </TableCell>

                                            <TableCell>
                                                {
                                                    GetTimeFormat(
                                                        log.duration || 0
                                                    )
                                                }
                                            </TableCell>

                                            <TableCell>

                                                {
                                                    log.recording_url ? (

                                                        <IconButton
                                                            onClick={() =>
                                                                window.open(
                                                                    log.recording_url,
                                                                    '_blank'
                                                                )
                                                            }
                                                        >
                                                            <PlayArrowIcon
                                                                color="primary"
                                                            />
                                                        </IconButton>

                                                    ) : (
                                                        '-'
                                                    )
                                                }

                                            </TableCell>

                                        </TableRow>

                                    ))
                                }

                            </TableBody>

                        </Table>

                    </TableContainer>

                </DialogContent>

            </Dialog>
        </Box>


    );
}